// extracted by mini-css-extract-plugin
export default {"root":"page-template_root__TDIJ5","pageContent":"page-template_pageContent__PSKG_"};